import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { InvitePage } from '@/components/InvitePage/InvitePage'

const inviteSearchSchema = z.object({
  token: z.string().optional(),
})

export const Route = createFileRoute('/auth/invite')({
  validateSearch: inviteSearchSchema,
  component: () => {
    const { token } = Route.useSearch()
    return <InvitePage token={token} />
  },
})
